export enum ProductCategory {
  phones = 'phones',
  tablets = 'tablets',
  accessories = 'accessories',
}
